import { render, staticRenderFns } from "./QContestsSubmenu.vue?vue&type=template&id=2ff0fdb6&"
import script from "./QContestsSubmenu.vue?vue&type=script&lang=js&"
export * from "./QContestsSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports